
import { jwtDecode } from "jwt-decode";
import moment from "moment";
import { aesUtil } from "../utils/aesUtil";
const MAX_RESEND_ATTEMPTS = 3;

const convertedClaimIntimation = (originalObject) => {
    const convertedArray = Object.keys(originalObject)
        .filter(key => typeof originalObject[key] === 'object' && originalObject[key] !== null)
        .map(key => ({
            name: originalObject[key].name,
            value: "",
            rec_name: key,
            behaviour: originalObject[key].behaviour,
            isEditable: originalObject[key].isEditable,
            fieldSize: originalObject[key].fieldSize,
            fieldType: originalObject[key].fieldType,
            isMultipleSelection: originalObject[key].isMultipleSelection,

        }));
    return convertedArray

}

const startTimer = (setTimerForOtp) => {
    const initialTime = + process.env.REACT_APP_TIMER_TIME;
    setTimerForOtp(initialTime);

    const intervalForOtp = setInterval(() => {
        setTimerForOtp((prevTimer) => {
            if (prevTimer <= 1) {
                clearInterval(intervalForOtp);
                return 0;
            }
            return prevTimer - 1;
        });
    }, 1000);
};

const isOtpLimitReached = (loginType) => {
    if (loginType.login === "old_login") {
        return parseInt(localStorage.getItem("resendOtpOldLoginCount")) >= MAX_RESEND_ATTEMPTS;
    } else if (loginType.login === "new_login") {
        return parseInt(localStorage.getItem("resendOtpNewLoginCount")) >= MAX_RESEND_ATTEMPTS;
    } else {
        return parseInt(localStorage.getItem("resendOtpResetCount")) >= MAX_RESEND_ATTEMPTS;
    }
};


const generateCurrentFY = () => {
    const currentYear = new Date().getFullYear();
    const pastYear = new Date().getFullYear() - 1;
    const futureYear = new Date().getFullYear() + 1;

    const leftYear = (new Date() < new Date(`${currentYear}-03-31`) && new Date() > new Date(`${pastYear}-04-01`)) ? pastYear : (new Date() > new Date(`${currentYear}-03-31`) && new Date() < new Date(`${futureYear}-04-01`)) ? currentYear : '';

    const rightYear = (new Date() < new Date(`${currentYear}-03-31`) && new Date() > new Date(`${pastYear}-04-01`)) ? currentYear : (new Date() > new Date(`${currentYear}-03-31`) && new Date() < new Date(`${futureYear}-04-01`)) ? futureYear : '';

    const currentFY = `${leftYear.toString()}-${rightYear.toString().substring(2, 4)}`;

    return { currentFY, currentFYLeftYear: leftYear }

}

//return previous year
//if fy = 2022-23 then it will return 2022
//if fy = 2022-23 then it will return 2022-23 
const generateFYList = (pastNumberOfYears, futureNumberOfYears) => {
    const { currentFY, currentFYLeftYear } = generateCurrentFY();

    const pastFYLeftYearList = [];
    const futureFYLeftYearList = [];
    const pastFYList = [];
    const futureFYList = [];

    for (let i = pastNumberOfYears; i >= 1; i--) {
        const leftYear = new Date().getFullYear() - i;
        const rightYear = leftYear + 1;
        const pastFY = `${(leftYear).toString()}-${(rightYear).toString().substring(2, 4)}`;
        pastFYLeftYearList.push({ label: pastFY, value: leftYear });
        pastFYList.push({ label: pastFY, value: pastFY });
    }

    for (let i = 0; i < futureNumberOfYears; i++) {
        const leftYear = new Date().getFullYear() + i;
        const rightYear = leftYear + 1;
        const futureFY = `${(leftYear).toString()}-${(rightYear).toString().substring(2, 4)}`;
        futureFYLeftYearList.push({ label: futureFY, value: leftYear });
        futureFYList.push({ label: futureFY, value: futureFY });
    }
    let FYLeftYearList, FYList = [];
    const isCurrFYIncluded = pastFYLeftYearList.findIndex((year) => year.value === currentFYLeftYear)
    const isCurrFYIncludedInFuture = futureFYLeftYearList.findIndex((year) => year.value === currentFYLeftYear)

    if (isCurrFYIncluded != -1 || isCurrFYIncludedInFuture != -1) {
        FYLeftYearList = [...pastFYLeftYearList, ...futureFYLeftYearList];
        FYList = [...pastFYList, ...futureFYList]
    } else {
        FYLeftYearList = [...pastFYLeftYearList, { label: currentFY, value: currentFYLeftYear }, ...futureFYLeftYearList];
        FYList = [...pastFYList, { label: currentFY, value: currentFY }, ...futureFYList]
    }

    return { FYList, FYLeftYearList };
}


const generateCurrentFYDates = () => {
    const currentYear = new Date().getFullYear();
    const pastYear = new Date().getFullYear() - 1;
    const futureYear = new Date().getFullYear() + 1;

    const leftYear = (new Date() < new Date(`${currentYear}-03-31`) && new Date() > new Date(`${pastYear}-04-01`)) ? pastYear : (new Date() > new Date(`${currentYear}-03-31`) && new Date() < new Date(`${futureYear}-04-01`)) ? currentYear : '';

    const rightYear = (new Date() < new Date(`${currentYear}-03-31`) && new Date() > new Date(`${pastYear}-04-01`)) ? currentYear : (new Date() > new Date(`${currentYear}-03-31`) && new Date() < new Date(`${futureYear}-04-01`)) ? futureYear : '';

    const currentFYStartDate = new Date(`${leftYear}-04-01`)

    const currentFYEndDate = new Date(`${rightYear}-03-31`)

    return { currentFYStartDate, currentFYEndDate };
}

const getFinancialYearStartEndDates = (year) => {
    // year = "2024-25"
    const leftYear = year ? year.split('-')[0] : '';
    const rightYear = year ? `20${year.split('-')[1]}` : '';
    const currentFYStartDate = leftYear ? `${leftYear}-04-01` : '';
    const currentFYEndDate = rightYear ? `${rightYear}-03-31` : '';
    return { currentFYStartDate, currentFYEndDate };
}

const formatDate = (date) => {
    return date ? moment(date).format('DD-MM-YYYY') : null;
}

const searchOnEnter = (e, selectSearch) => {
    if (e.key === 'Enter') {
        selectSearch();
    }
};


const isTwoObjectsEqual = (obj1, obj2) => {
    // Get the keys of both objects
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    // Check if both objects have the same number of keys
    if (keys1.length !== keys2.length) {
        return false;
    }

    // Check if all keys and their corresponding values are the same
    for (let key of keys1) {
        // If the key is not present in the second object or the values are different, return false
        if (!Object.prototype.hasOwnProperty.call(obj2, key) || obj1[key] !== obj2[key]) {
            return false;
        }
    }

    // If all checks pass, the objects are equal
    return true;
}

const mergeDatesToFY = (fromDate, toDate) => {
    const fromYear = fromDate?.split('-')[0];
    const toYear = toDate?.split('-')[0];
    return `${fromYear}-${toYear?.slice(-2)}`;
};

const getLoggedInUser = () => {
    // let data = localStorage.getItem('token');
    // const decoded = typeof data === 'string' ? jwtDecode(data) : null;
    // const userRole = decoded?.Role;
    let data = localStorage.getItem('token');
    const decryptToken = typeof data === 'string' ? aesUtil.decrypt(data) : '';
    const decoded = typeof decryptToken === 'string' ? jwtDecode(decryptToken) : null;
    if (decoded) {
        return decoded;
    }
    return '';
}

const countDotsInFileName = (fileName) => {
    if (fileName) {
        return (fileName?.match(/\./g) || [])?.length;
    }
    return null
};

const getFileExtension = (mimeType) => {
    const validMimeTypesMap = {
        'image/png': 'png',
        'image/jpeg': 'jpg',
        // 'image/gif': 'gif',
        'application/pdf': 'pdf',
        'application/msword': 'doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
        'text/plain': 'txt',
        // 'audio/mpeg': 'mp3',
        // 'video/mp4': 'mp4'
        'application/vnd.ms-excel': 'xls',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx'
    };

    return validMimeTypesMap[mimeType] || 'unknown'; // If MIME type is not in the map, return 'unknown'
};



const isFileExtValid = (mimeType, fileName, acceptedExt = []) => {
    //check double ext
    const dotCount = countDotsInFileName(fileName);
    if (dotCount > 1) {
        return false;
    } else {
        const fileExt = getFileExtension(mimeType);
        if (fileExt === 'unknown') {
            return false
        } else {
            if (acceptedExt?.length > 0) {
                if (Array.isArray(fileExt)) {
                    return fileExt.some(ext => acceptedExt.includes(ext));
                } else {
                    return acceptedExt.includes(fileExt);
                }
            } else {
                return true
            }
        }
    }
}

export {
    startTimer,
    isOtpLimitReached,
    generateCurrentFY,
    generateFYList,
    isTwoObjectsEqual,
    generateCurrentFYDates,
    getFinancialYearStartEndDates,
    formatDate,
    mergeDatesToFY,
    convertedClaimIntimation,
    getLoggedInUser,
    searchOnEnter,
    isFileExtValid
}